import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  Typography,
  Grid,
  IconButton,
  Autocomplete,
  TextField,
} from "@mui/material";
import { CloseSharp } from "@mui/icons-material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";
import { FailurePop, SuccessPop } from "../Popup";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import { AppContext } from "../context/app.context";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export default function AddCar({ openAddCar, setOpenAddCar }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { fetchCarList } = useContext(AppContext);
  const signIn = global.$signInStatus;

  //useState
  const [brandDrop, setBrandDrop] = useState([]);
  const [brandValue, setBrandValue] = useState(null);
  const [modelDrop, setModelDrop] = useState([]);
  const [modelValue, setModelValue] = useState(null);
  const [typeDrop, setTypeDrop] = useState([]);
  const [typeValue, setTypeValue] = useState(null);
  const [year, setYear] = useState(null);
  const [registerNo, setRegisterNo] = useState("");
  const [regVali, setRegVali] = useState(false);
  const [modalFail, setModalFail] = useState(false);
  const [modalSuccess, setModalSuccess] = useState(false);
  const [content, setContent] = useState("");
  const [loader, setLoader] = useState(false);
  const [validate, setValidate] = useState([
    {
      brand: false,
      model: false,
      type: false,
      year: false,
      rno: false,
      rnoVali: false,
    },
  ]);
  //Functions

  const handleRegNo = (text) => {
    const alphanumericRegex = /^[a-zA-Z0-9]*$/;
    if (alphanumericRegex.test(text) && text.length < 16) {
      setRegisterNo(text);
    }
  };

  //APIs
  const brandList = async () => {
    try {
      const response = await global.$axios.get("brand/list");
      // console.log("brand", response.data);
      if (response.data.status == "success") {
        var change = response.data.getList.sort((a, b) => {
          let aa = a.name.toLowerCase(),
            bb = b.name.toLowerCase();
          if (aa > bb) return 1;
          if (aa < bb) return -1;
          if (aa == bb) return 0;
        });
        setBrandDrop(change);
      } else {
        setBrandDrop([]);
      }
    } catch (error) {
      console.log("Brand List Issue", error);
    }
  };

  const modelList = async (val) => {
    try {
      const response = await global.$axios.post("car_model/list", {
        brand_id: val,
      });
      // console.log("modelList", response.data);
      if (response.data.status == "success") {
        var change = response.data.list.sort((a, b) => {
          let aa = a.name.toLowerCase(),
            bb = b.name.toLowerCase();
          if (aa > bb) return 1;
          if (aa < bb) return -1;
          if (aa == bb) return 0;
        });
        setModelDrop(change);
      } else {
        setModelDrop([]);
      }
    } catch (error) {
      console.log("Model List Issue", error);
    }
  };

  const typeList = async (val) => {
    try {
      const response = await global.$axios.post("car_type/list", {
        model_id: val,
      });
      // console.log("typeList", response.data);
      if (response.data.status == "success") {
        var change = response.data.message.sort((a, b) => {
          let aa = a.name.toLowerCase(),
            bb = b.name.toLowerCase();
          if (aa > bb) return 1;
          if (aa < bb) return -1;
          if (aa == bb) return 0;
        });
        setTypeDrop(change);
        setTypeValue(change[0]);
      } else {
        setTypeDrop([]);
      }
    } catch (error) {
      console.log("Type List Issue", error);
    }
  };

  const registerValidate = async (e) => {
    var pattern = /^[A-Z]{2}[ -]?[0-9]{2}[ -]?[A-Z]{2}[ -]?[0-9]{4}$/;
    if (e.match(pattern)) {
      setRegVali(false);
    } else {
      setRegVali(true);
    }
  };

  const fieldValidate = async () => {
    if (!brandValue) {
      setValidate((validate) => ({ ...validate, brand: true }));
    } else {
      setValidate((validate) => ({ ...validate, brand: false }));
    }

    if (!modelValue) {
      setValidate((validate) => ({ ...validate, model: true }));
    } else {
      setValidate((validate) => ({ ...validate, model: false }));
    }

    if (!typeValue) {
      setValidate((validate) => ({ ...validate, type: true }));
    } else {
      setValidate((validate) => ({ ...validate, type: false }));
    }

    if (!year) {
      setValidate((validate) => ({ ...validate, year: true }));
    } else {
      setValidate((validate) => ({ ...validate, year: false }));
    }

    if (!registerNo || registerNo.length < 5) {
      setValidate((validate) => ({ ...validate, rno: true }));
    } else {
      setValidate((validate) => ({ ...validate, rno: false }));
    }
    if (
      !brandValue ||
      !modelValue ||
      !typeValue ||
      !year ||
      !registerNo ||
      regVali ||
      registerNo.length < 5
    ) {
      setContent("Please Provide Required Fields");
      setModalFail(true);
      setTimeout(() => {
        setModalFail(false);
      }, 1500);
      return true;
    } else {
      addCar();
    }
  };

  const addCar = async () => {
    try {
      const data = {
        brand_id: brandValue?._id,
        model_id: modelValue?._id,
        type_id: typeValue?._id,
        year: moment(year?.$d).format("YYYY"),
        reg_number: registerNo,
        size_id: typeValue?.car_size_id,
        color: "",
        engine_no: "",
        chassis_no: "",
        renewal_date: "",
      };
      const response = await global.$axios.post("customer/addVehicle", data);
      console.log("data", data, response.data);
      if (response.data.status == "success") {
        setContent("Vehicle Added Successfully");
        setModalSuccess(true);
        setOpenAddCar(false);
        fetchCarList();
        setTimeout(() => {
          setModalSuccess(false);
          setBrandValue(null);
          modelList("");
          setModelValue(null);
          setTypeValue(null);
          typeList("");
          setRegisterNo("");
          setYear(null);
        }, 2000);
      } else {
        setContent(response.data.message);
        setModalFail(true);
        setTimeout(() => {
          setModalFail(false);
        }, 2000);
      }
    } catch (error) {
      setContent("Something Went Wrong, Try Again");
      setModalFail(true);
      setTimeout(() => {
        setModalFail(false);
      }, 2000);
      setLoader(false);
      console.log("Add Car Issue", error);
    }
  };

  const handleClose = () => {
    setOpenAddCar(false);
  };

  useEffect(() => {
    if (signIn) {
      brandList();
    }
  }, [signIn]);

  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={openAddCar}
        fullWidth={true}
        maxWidth={"sm"}
        TransitionComponent={Transition}
        aria-labelledby="draggable-dialog-title"
        PaperComponent={PaperComponent}
        onClose={() => setOpenAddCar(false)}
      >
        <Grid sx={{ py: 2, px: 3 }}>
          <Grid
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <DialogTitle>
              <Typography sx={{ p: 0, color: "#071CB7", fontWeight: 600 }}>
                New Car
              </Typography>
            </DialogTitle>
            <IconButton sx={{ p: 0 }} onClick={() => setOpenAddCar(false)}>
              <CloseSharp sx={{ color: "red" }} />
            </IconButton>
          </Grid>
          <DialogContent sx={{ px: { sm: 5, xs: 0 } }}>
            <Grid>
              <TextField
                value={registerNo}
                onChange={(e) => {
                  handleRegNo(e.target.value.toUpperCase());
                }}
                size="small"
                sx={{ mt: 3 }}
                fullWidth
                label={
                  validate.rno
                    ? "Minimum 5 Digit Required"
                    : "Registration Number"
                }
                inputProps={{ maxLength: 15 }}
                required
                error={validate.rno}
                helperText={
                  regVali ? (
                    <Typography sx={{ color: "red" }}>
                      Minimum 5 Digit Required
                    </Typography>
                  ) : (
                    <Typography sx={{ color: "transparent" }}>
                      Invalid
                    </Typography>
                  )
                }
              />
              <Autocomplete
                value={brandValue}
                onChange={(event, newValue) => {
                  setBrandValue(newValue);
                  modelList(newValue ? newValue._id : "");
                  setModelValue(null);
                  setTypeValue(null);
                  typeList("");
                }}
                options={brandDrop}
                size="small"
                autoComplete
                getOptionLabel={(option) => option.name || ""}
                isOptionEqualToValue={(option, value) =>
                  option.name == value.name
                }
                fullWidth
                sx={{ mb: 3, borderRadius: 3 }}
                renderInput={(params) => (
                  <TextField
                    label="Car Brand"
                    variant="outlined"
                    required
                    {...params}
                    error={validate.brand}
                  />
                )}
              />
              <Autocomplete
                value={modelValue}
                onChange={(event, newValue) => {
                  setModelValue(newValue);
                  typeList(newValue ? newValue._id : "");
                  setTypeValue(null);
                }}
                options={modelDrop}
                size="small"
                autoComplete
                getOptionLabel={(option) => option.name || ""}
                isOptionEqualToValue={(option, value) =>
                  option.name == value.name
                }
                fullWidth
                renderInput={(params) => (
                  <TextField
                    label="Car Model"
                    variant="outlined"
                    {...params}
                    required
                    error={validate.model}
                  />
                )}
              />

              <Autocomplete
                value={typeValue}
                onChange={(event, newValue) => {
                  setTypeValue(newValue);
                }}
                options={typeDrop}
                size="small"
                autoComplete
                disabled
                getOptionLabel={(option) => option.name || ""}
                isOptionEqualToValue={(option, value) =>
                  option.name == value.name
                }
                sx={{ mt: 3 }}
                fullWidth
                renderInput={(params) => (
                  <TextField
                    label="Car Type"
                    variant="outlined"
                    {...params}
                    required
                    error={validate.type}
                  />
                )}
              />

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <MobileDatePicker
                  views={["month", "year"]}
                  label="Model Year *"
                  openTo="month"
                  fullWidth
                  sx={{ mt: 3 }}
                  maxDate={dayjs()}
                  value={year}
                  onChange={(newValue) => {
                    setYear(newValue);
                  }}
                  slotProps={{
                    textField: {
                      size: "small",
                      fullWidth: true,
                      error: validate.year,
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
          </DialogContent>

          <Grid sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <Button
              size="small"
              variant="contained"
              sx={{ textTransform: "capitalize", px: 3, background: "#071CB7" }}
              onClick={() => fieldValidate()}
            >
              Add Car Details
            </Button>
          </Grid>
          {/* <Grid sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
            <Button
              sx={{
                textTransform: "capitalize",
                color: "#071CB7",
              }}
              size="small"
            >
              Add car with Registration Number
            </Button>
          </Grid> */}
        </Grid>
      </Dialog>
      {modalSuccess && (
        <SuccessPop
          modalSuccess={modalSuccess}
          setModalSuccess={setModalSuccess}
          content={content}
        />
      )}
      {modalFail && (
        <FailurePop
          modalFail={modalFail}
          setModalFail={setModalFail}
          content={content}
        />
      )}
    </React.Fragment>
  );
}
